import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { formItem } from '../preview-forms.interface';

@Component({
    selector: 'app-form-short',
    templateUrl: './form-short.component.html',
    styleUrls: ['./form-short.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormShortComponent {
  form!: formItem
  @Input('model') set item(v: formItem) {
    this.form = v;
    this.errorMsg = '';
  }

  @Output('update') update = new EventEmitter()
  @Output('valid') valid = new EventEmitter()

  errorMsg: string = '';

  validateFormat(value: string): boolean {
    const type = this.form?.validation_type;
    if (!type || !value || !value.trim()) {
      this.errorMsg = '';
      return true;
    }
    if (type === 'email') {
      const ok = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);
      this.errorMsg = ok ? '' : 'รูปแบบอีเมลไม่ถูกต้อง';
      return ok;
    }
    if (type === 'number') {
      const ok = value.trim() !== '' && !isNaN(Number(value));
      this.errorMsg = ok ? '' : 'กรุณากรอกตัวเลข';
      return ok;
    }
    this.errorMsg = '';
    return true;
  }

  updateValue(form: any, v: any) {
    form.answer_value = v.value
    this.update.emit(v.value)
    const ok = this.validateFormat(v.value)
    if (v.value && !ok) {
      this.valid.emit(true)
    } else {
      if (form.answer_value) this.valid.emit(false)
    }
  }

  updateValiDate(e: any) {
    this.valid.emit(e)
  }
}
